import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import { ModuleDoneType, ModuleType, PlanType } from "../../templates/types";

export const QuickstartPollTemplate: PlaniraTemplate = {
  planType: PlanType.Quickstart,
  type: PlanTemplateType.QuickstartPoll,
  title: "Create a Poll",
  description:
    "Pose a question, add options, and vote to determine the group's favorite choice.",
  longDescription: "",
  emoji: "📥",
  titleHelp: "Valid passports? What movie do you prefer? Budget? What to eat?",
  image: require("../../assets/illustrations/Choose-pana.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "N/A",
          isDraggable: false,
          emoji: "📥",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Poll,
          doneType: ModuleDoneType.Voting,
          title: "Poll",
          emoji: "📥",
        },
      ],
    },
  ],
};
